<template>
  <div class="station-alarm">
    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />
    <div
      v-if="computedAlarmIsActive && !synced"
      class="spinner"
    />

    <div
      v-if="computedAlarmIsActive && synced"
      class="g-alarm-handler__row"
    >
      <h3
        v-if="computedFaultedStations.length"
        class="g-text"
      >
        {{ $t('messages.sharedTexts.status.faulted') }} {{ $tc('messages.sharedTexts.stations.station', 0) }}
      </h3>
      <mini-stations-element :stations="computedFaultedStations" />

      <!-- <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceStationAlarm.suggestionActive') }}</p> -->
      <div class="g-text g-text--center">
        <selective-survey-button :stations="computedFaultedStations" />
      </div>
    </div>

    <div
      v-if="!computedAlarmIsActive"
      class="g-alarm-handler__row"
    >
      <h3
        class="g-text g-text--center"
      >
        {{ $t('messages.alarms.suggestion') }}
      </h3>

      <p>{{ $t('messages.alarms.noAttention') }}</p>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import ServiceSelectiveSurveyButton from '@/components/elements/ServiceSelectiveSurveyButton'
import MiniStationsElement from '@/components/elements/MiniStationsElement'

export default {
  name: 'ServiceStationAlarm',
  components: {
    'selective-survey-button': ServiceSelectiveSurveyButton,
    'mini-stations-element': MiniStationsElement
  },
  mixins: [ServiceAlarm],
  props: {
    store: {
      type: Object,
      default: function() {
        return {}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      synced: false
    }
  },
  computed: {
    computedFaultedStations() {
      let rtn = []
      const stations = this.store.getData('stations')

      if(stations && stations.length) {
        rtn = stations.filter(stations => stations.status === '1')
      }

      return rtn
    }
  },
  watch: {
    SocketMessage(msg) {
      if(
        msg &&
        msg.data &&
        msg.data.category &&
        msg.data.category === 'server'&&
        msg.data.command &&
        msg.data.command === 'synchronize' &&
        msg.data.data &&
        msg.data.data.status && msg.data.data.status === 'OK') {
        this.synced = true
      }
    }
  }
}
</script>

<style lang="scss">
  .station-alarm {
    h3.g-text {
      margin: 20px 0 15px;
    }
    .spinner {
      @include spinner('after', 80px, 5px, $color-grey);
      margin-top: 35px;
      &:after {
        display: block;
        margin: 0 auto;
      }
    }
  }
</style>
